function toTarget(e){
    e.preventDefault();
    let what = (e.target.hash || e.target.parentNode.hash).slice(1);
    document.getElementById(what).scrollIntoView({behavior: 'smooth'});
}
export default toTarget;